module.exports = function() {
  return new Worker(__webpack_public_path__ + "781dbc04cfe90984c229.worker.js");
};